import React from 'react';
import styled from 'styled-components';
import { 
  COLORS, 
  ComponentM, 
  ComponentTextStyle, 
  SystemIcons
} from '@laerdal/life-react-components';

const QcprModalLinkContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    transition: all 0.2s ease;

    border-radius: 8px;
    border: 1px solid ${COLORS.neutral_200};
    background: ${COLORS.white};
`;

const QcprModalLinkLine1 = styled.div`
    display: flex;
    padding: 4px 16px;
    align-items: flex-start;
    align-self: stretch;
`;

const QcprModalLinkLine1Icon = styled.div`
    display: flex;
    padding: 12px 12px 12px 0;
    justify-content: center;
    align-items: center;
    color: ${COLORS.primary_500};
`;

const QcprModalLinkLine1Text = styled.div`
    display: flex;
    padding: 12px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
`;

const QcprModalLinkLine2Text = styled.div`
    display: flex;
    padding: 0 16px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

interface QcprModalLinkProps {
  title: string;
  description: string;
  onClick: () => void;
  icon?: React.ComponentType<{ size?: string; color?: string }>;
  iconSize?: string;
  iconColor?: string;
}

const QcprModalLink: React.FC<QcprModalLinkProps> = ({
  title,
  description,
  onClick,
  icon: Icon = SystemIcons.Mail,
  iconSize = '24px',
  iconColor = COLORS.primary_500
}) => {
  return (
    <QcprModalLinkContainer onClick={onClick}>
      <QcprModalLinkLine1>
        <QcprModalLinkLine1Icon>
          <Icon size={iconSize} color={iconColor} />
        </QcprModalLinkLine1Icon>
        <QcprModalLinkLine1Text>
          <ComponentM textStyle={ComponentTextStyle.Bold}>{title}</ComponentM>
        </QcprModalLinkLine1Text>
      </QcprModalLinkLine1>
      <QcprModalLinkLine2Text>
        {description}
      </QcprModalLinkLine2Text>
    </QcprModalLinkContainer>
  );
};

export default QcprModalLink;
